import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

export function isLevel3<Props extends JSX.IntrinsicAttributes>(
  Component: React.FC<Props>
): React.FC<Props> {
  const Wrapper: React.FC<Props> = (props) => {
    const user = useUser();
    if ((user?.role?.toLowerCase() || "") !== "level 3" && (user?.role?.toLowerCase() || "") !== "system admin") {
      return <Navigate to="/onboarding/login" replace />;
    }
    return <Component {...props} />;
  };
  return Wrapper;
}
